import React, { createContext, useContext } from "react";
import FAQStructuredData from "./FAQStructuredData";

const ArticleMetaContext = createContext({});

export function ArticleMetaProvider({ value, children }) {
	const articleMeta = value || {};

	return (
		<ArticleMetaContext.Provider value={articleMeta}>
			<FAQStructuredData items={articleMeta.faqItems} />
			{children}
		</ArticleMetaContext.Provider>
	);
}

export function useArticleMeta() {
	return useContext(ArticleMetaContext) || {};
}
